import { IntlProvider } from 'react-intl';
import { createTransform } from 'redux-persist';
import intlMessages from './../i18n/base-en';
import { createExpireDate } from './utils';

function dateToUnix(date: Date) {
  return +(date.getTime() / 1000).toFixed(0);
}

export default function createExpirationTransform(expireConfigs: object) {
  expireConfigs = expireConfigs || {};

  const inbound = (state: any, reducer: string) => {
    if ((state || typeof state === 'object') && expireConfigs.hasOwnProperty(reducer)) {
      if (typeof state.toJS === 'function') {
        const newState = state.toJS();
        newState.expireDate = createExpireDate(expireConfigs[reducer].expireSpan);
        return newState;
      } else {
        state.expireDate = createExpireDate(expireConfigs[reducer].expireSpan);
      }
    }
    return state;
  };

  const outbound = (state: any, reducer: string) => {
    if ((state || typeof state === 'object') && expireConfigs.hasOwnProperty(reducer)) {
      if (state.expireDate) {
        const expireConfig = expireConfigs[reducer];
        if (dateToUnix(new Date(state.expireDate)) < dateToUnix(new Date())) {
          state = expireConfig.default;
          const { intl } = new IntlProvider({ ...state.intlData }, {}).getChildContext();
          const { formatMessage } = intl;
          const error = {
            error: true,
            messages: [formatMessage(intlMessages.expire_error_message)]
          };
          state.errors = error;
        }
      }
    }
    return state;
  };

  return createTransform(inbound, outbound);
}
